export enum BillingPeriod {
  Monthly = 'monthly',
  Yearly = 'yearly',
}
